// extracted by mini-css-extract-plugin
module.exports = {"root":"ChecklistItem_root___ELhD","iconWrap":"ChecklistItem_iconWrap__i0blQ","icon":"ChecklistItem_icon__3k_5r"};